import React, { useState, useEffect, useRef } from "react";
import "./BusinessThreeAboutUs.scss";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import CountUp from "react-countup";

const BusinessThreeAboutUs = ({ id }) => {
  const counterRef = useRef(null);
  const [counterKey, setCounterKey] = useState(Date.now());

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Update key to restart counters
            setCounterKey(Date.now());
          }
        });
      },
      { threshold: 0.5 } // Adjust threshold as needed
    );

    if (counterRef.current) {
      observer.observe(counterRef.current);
    }

    return () => {
      if (counterRef.current) {
        observer.unobserve(counterRef.current);
      }
    };
  }, []);

  return (
    <div style={{ backgroundColor: "var(--white-color)" }} id={id}>
      <div className="large_padding_div"></div>
      <div className="large_padding_div"></div>

      <div className="container">
        <div className="business-three-hero-hero-section">
          <div className="business-three-hero-hero-left">
            <OwlCarousel
              className="business-three-hero-owl-theme"
              loop
              autoplay
              margin={10}
              items={1}
            >
              <div className="business-three-hero-carousel-item">
                <div className="business-three-hero-image-wrapper">
                  <img
                    src="https://i.pinimg.com/474x/b6/aa/91/b6aa915a8af1139561f0b9ec24a2e5af--modern-hotel-room-hotel-style-bedrooms.jpg"
                    alt="Carousel 1"
                  />
                </div>
                <div className="business-three-hero-carousel-text">
                  <h1>
                    Delivering top linen & reliable workwear for multi
                    industries
                  </h1>
                  <br />
                  <p>
                    We provide high-quality linen and durable workwear tailored
                    to meet the diverse needs of different industries.
                  </p>
                </div>
              </div>
              <div className="business-three-hero-carousel-item">
                <div className="business-three-hero-image-wrapper">
                  <img
                    src="https://www.luxuryholidays.co.uk/assets/components/phpthumbof/cache/img10.d0a7d74015e2eb3e5e135b5c482bcd97.jpg"
                    alt="Carousel 2"
                  />
                </div>
                <div className="business-three-hero-carousel-text">
                  <h1>Excellence in linen & workwear solutions</h1>
                  <br />
                  <p>
                    Our dedication lies in offering superior linen products and
                    cutting-edge workwear, ensuring comfort and efficiency for
                    all users.{" "}
                  </p>
                </div>
              </div>
            </OwlCarousel>
            <div className="business-three-hero-search-bar">
              <input type="text" placeholder="Find in and around..." />
              <button>Search</button>
            </div>
          </div>
          <div className="business-three-hero-hero-right">
            <div className="business-three-hero-hero-card">
              <img
                src="https://bk.asia-city.com/sites/default/files/styles/og_fb/public/sireeampan_11_web.jpg?itok=WEbVInUq"
                alt="Eco-Friendly Solutions"
              />
              <div>
                <h3>Nature-Friendly Solutions</h3>
                <span className="material-symbols-outlined">arrow_forward</span>
              </div>
            </div>
            <div className="business-three-hero-hero-card">
              <img
                src="https://assets.anantara.com/image/upload/q_auto,f_auto/media/minor/anantara/images/anantara-hua-hin-resort/gallery/accom/7-tree-bedroom-condo/anantara_hua_hin_three_bedroom_condo_1_1920x1037.jpg?mw=1440"
                alt="Professional Dry Cleaning"
              />
              <div>
                <h3>Professional Dry Cleaning</h3>
                <span className="material-symbols-outlined">arrow_forward</span>
              </div>
            </div>
            <div className="business-three-hero-hero-card">
              <img
                src="https://i.ytimg.com/vi/uP-6ya2KF40/maxresdefault.jpg"
                alt="Quality Laundry Services"
              />
              <div>
                <h3>Quality Laundry Services</h3>
                <span className="material-symbols-outlined">arrow_forward</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref={counterRef} className="home-three-hero-banner-below-parent">
        <div className="container">
          <div className="row">
          <div className="col-4 d-flex align-items-center justify-content-center">
              <span className="material-symbols-outlined">groups</span> &nbsp;
              <h5 style={{ color: "var(--black-color)" }}>
                <CountUp
                  key={`customers-${counterKey}`}
                  start={0}
                  end={5000}
                  duration={3}
                  suffix="+"
                />
                <span> Customers</span>
              </h5>
            </div>
           
            <div className="col-4 d-flex align-items-center justify-content-center">
              <span className="material-symbols-outlined">wifi</span> &nbsp;
              <h5 style={{ color: "var(--black-color)" }}>
                <CountUp
                  key={`services-${counterKey}`}
                  start={0}
                  end={150}
                  duration={4}
                  suffix="+"
                />
                <span> Services</span>
              </h5>
            </div>
            <div className="col-4 d-flex align-items-center justify-content-center">
              <span className="material-symbols-outlined">home_work</span>{" "}
              <h5 style={{ color: "var(--black-color)" }}>
                <CountUp
                  key={`cities-${counterKey}`}
                  start={0}
                  end={24}
                  duration={4}
                  suffix="+"
                />
                <span> Cities</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessThreeAboutUs;
